import { useCallback } from "react";

import { useQuery } from "hooks";

export default function useImportedStatus() {
  const factory = useCallback(() => {
    const query = `
      query crmContactStatuses {
        hub {
          contactStatuses {
            externalId
            name
            contactCount
            isExcluded
          }
        }
      }
    `;

    const resolver = ({ data: { hub }, errors }) => {
      if (errors?.length > 0) throw errors;
      return hub?.contactStatuses?.map((status) => {
        return { ...status, count: status.contactCount };
      });
    };

    return { query, resolver };
  }, []);

  const { loading, data, error, reloadData } = useQuery(factory);

  return {
    loading: loading,
    data: data,
    error: error
      ? `${
          error[0]?.message || "Failed to load contact status table"
        }. Please refresh the page or contact support for further assistance.`
      : null,
    reloadData: reloadData,
  };
}
